import { InputBase, InputPayStatsRowTypeController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Form control for defining row type for pay statistics calculations.
 * @example
 * ```html
 * <salaxy-input-pay-stats-row-type name="salaryType" ng-model="row.salaryType" label="Row type or custom type"></salaxy-input-pay-stats-row-type>
 * ```
 */
export class InputPayStatsRowType extends ComponentBase {

    /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
    public require = {
      model: "ngModel",

      form: "?^^form",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = InputBase.crudBindings;

    /** Uses the InputPayStatsRowTypeController */
    public controller = InputPayStatsRowTypeController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/InputPayStatsRowType.html";
}
